export default __webpack_public_path__ + "static/media/leftArrow.d73872ce.svg";